import { Button, Card, Col, Flex, Form, Input, message, Row, Tag } from "antd";
import { useEffect } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { userService } from "../services/user.service";
import RenderIf from "../components/RenderIf";

export default function Profile(){

  const [ form ] = Form.useForm()
  const [ passwordForm ] = Form.useForm()

  const [messageApi, contextHolder] = message.useMessage()

  const { data } = useQuery({
    queryKey: ['user'],
    queryFn: () => userService.getProfile()
  })

  useEffect(() => {
    form.setFieldsValue(data?.data)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const changePasswordMutation = useMutation({
    mutationFn: val => userService.changePassword(val),
    onSuccess: () => {
      messageApi.success("Password Berhasil di ubah")
      passwordForm.resetFields()
    },
    onError: () => {
      messageApi.success("Terjadi Kesalahan")
    }
  })

  return (
    <>
      {contextHolder}
      <Card
        title="Profile"
      >
        <Form
          form={form}
          layout="vertical"
        >
          <Row gutter={[20]} >
            <Col span={12} >
              <Form.Item name={'employeeId'} label="ID Pegawai" >
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item name={'name'} label="Nama Lengkap" >
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item name={'email'} label="Email" >
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item name={'phone'} label="No Telepon" >
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item name={'division'} label="Divisi" >
                <Input readOnly />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item name={'subdivision'} label="Subdivisi" >
                <Input readOnly />
              </Form.Item>
            </Col>
            <RenderIf when={['Surveyor', 'Officer', 'Marketing'].includes(data?.data.subdivision)} >
              <Col span={12} >
                <Form.Item label="Area Bisnis" >
                  {
                    data?.data?.ab?.map(e => <Tag style={{ fontSize: 13 }} key={e.OBJECTID} >{e.NAMA_AB}</Tag>)
                  }
                </Form.Item>
              </Col>
            </RenderIf>
          </Row>
        </Form>
      </Card>
      <Card
        title="Ubah Password"
        style={{ marginTop: 20 }}
        actions={[
          <Flex key={'1'} style={{ paddingRight: 24 }} justify="end" >
            <Button onClick={() => passwordForm.submit()} type="primary" >
              Submit
            </Button>
          </Flex>
        ]}
      >
        <Form
          form={passwordForm}
          layout="vertical"
          onFinish={val => changePasswordMutation.mutate(val)}
        >
          <Row gutter={[20]} >
            <Col span={12} >
              <Form.Item rules={[{ required: true }]} name={'oldPassword'} label="Password Lama" >
                <Input.Password />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item 
                rules={[
                  { required: true },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('oldPassword') === value) {
                        return Promise.reject(new Error('Password baru tidak boleh sama dengan password lama'));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]} 
                name={'newPassword'} 
                label="Password Baru" 
              >
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  )
}